import { Component, inject, Input, Signal, ChangeDetectionStrategy } from '@angular/core';

import { EMessageLevel, IMessageUi } from '../../domain/message-ui.model';
import { UUID } from '@okcargo-apps/shared-domain';
import { MessagesUiService } from '../../application/message-ui.service';
import { IonButton, IonIcon } from '@ionic/angular/standalone';

@Component({
  selector: 'lib-message-ui-ionic',
  imports: [IonIcon, IonButton],
  templateUrl: './message-ui-ionic.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './message-ui-ionic.component.scss',
})
export class MessageUiIonicComponent {
  @Input({ required: true })
  messages!: Signal<IMessageUi[]>;

  private readonly messagesUiService = inject(MessagesUiService);

  protected readonly EMessageLevel = EMessageLevel;

  protected removeMessage(messageId: UUID): void {
    this.messagesUiService.removeMessageById(messageId);
  }
}
